import { create } from "zustand";
import wsuiApi from "@api/wsuiApi";
import type { IUserMeResponse } from "@typing/wsui/userMe";
import { UserRole } from "@typing/wsui/userMe";

interface IUserStore {
    userInfo: IUserMeResponse | null;
    loading: boolean;
    /** 是否已登录（role !== -1 且 userInfo 存在） */
    isLogin: boolean;
    fetchUserInfo: () => Promise<void>;
    clearUserInfo: () => void;
}

export const useUserStore = create<IUserStore>((set) => ({
    userInfo: null,
    loading: false,
    isLogin: false,

    fetchUserInfo: async () => {
        try {
            set({ loading: true });
            const response = await wsuiApi.userMe({ businessType: 'doctor_youyi' });
            if (response.errno === 0 && response.data) {
                if (response.data.redirect_type === "oe") {
                    const isLogin = response.data.role !== UserRole.Unauthenticated;
                    set({ userInfo: response.data, isLogin });
                } else {
                    window.location.href = "/pc";
                }
            }
        } catch (error) {
            console.error("获取用户信息失败:", error);
        } finally {
            set({ loading: false });
        }
    },

    clearUserInfo: () => {
        set({ userInfo: null, isLogin: false, loading: false });
    },
}));
